import { catchHttpErrorFactory } from './catch-http-error.factory';

export const catch304 = catchHttpErrorFactory(304);
